// extracted by mini-css-extract-plugin
export default {"wrapper":"Tabs_wrapper__E-UOu","tabContatiner":"Tabs_tabContatiner__fdqAM","activeTab":"Tabs_activeTab__UG+pF"};